import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';

import styles from './ModalAddItem.css';

const ListItems = props => {
  const { items, onSelectItem, onMenuScrollToBottom } = props;

  return (
    <div className={styles['list-contain']}>
      <InfiniteScroll
        pageStart={0}
        loadMore={() => {
          onMenuScrollToBottom();
        }}
        useWindow={false}
        hasMore
        threshold={10}
        initialLoad={false}
      >
        <ul className={styles['list-item']}>
          {items.map((item, idx) => (
            <li
              onClick={() => onSelectItem(item)}
              className={`row ${styles['row-wrapper']}`}
              key={idx}
            >
              <div className={`col-sm-2 ${styles['item-image-wrapper']}`}>
                <img src={item.image} className={styles.image} />
              </div>
              <div className={`col-sm-9 ${styles['item-name-wrapper']}`}>
                <p>{item.label}</p>
              </div>
              <div
                className={`col-sm-1 pull-right ${styles['padding-checkbox']}`}
              />
            </li>
          ))}
        </ul>
      </InfiniteScroll>
    </div>
  );
};

export default ListItems;
